<template>
    <div>
        <div class="row">
            <div class="col text-center">
                <center><img class="icon" src="/hymns-icon-114-iPhone-2x.png" /></center>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col text-center">
                <h1>Hymnbooks Privacy Policy</h1>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col col-md-6 offset-md-3">
                This Hymnbooks app does not collect, use, or share information in connection with your use of our app.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HymnbooksPrivacyPolicy'
}
</script>

<style lang="scss">
</style>
